import { app } from '../../../../app';
import { Controller } from './software-license-management-add.controller';

app.component('companySoftwareLicenseManagementAdd', {
    bindings: {
        companyId: '<',
        applications: '<',
        selectedApp: '<',
    },
    controller: Controller,
    templateUrl: require('./software-license-management-add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/add/software-license-management-add.component.js